jQuery(document).ready(function($) {

  if (window.location.hash == '#submenu') {
    var scrollAmount = $('.page-template-page-event .submenu').offset().top
    scrollAmount -= $('.top-menu').height()
    $('html, body').animate({ scrollTop: scrollAmount  }, 0)
  }

})
